<template>
  <div class="top3">
    <div class="tHeader">精品课程</div>
    <div class="main">
      <div class="first" @click="openVideo(topCarse)">
        <img src="../../assets/img/home/bofang.png" alt="" class="bofang">
        <img :src="topCarse.acr_PictResUrl" class="img" alt="">
        <div class="title">{{ topCarse.title }} </div>
        <div class="morer">
          <img src="../../assets/img/icon/people5.png" alt="" />
          <span style="text-align: right;">{{ topCarse.playSum }}人</span>
        </div>
        <!-- <div class="bq" v-if="topCarse.labelName">
          <div class="child" v-for="(key, k) in topCarse.labelName.split(';')" :key="k">{{ key }}</div>
        </div> -->

      </div>
      <div class="last">
        <div class="item" v-for="(item, index) in list" :key="index" @click="openVideo(item)">
          <img src="../../assets/img/home/bofang.png" alt="" class="bofang">
          <img :src="item.acr_PictResUrl" class="img" alt="">
          <div class="title">{{ item.title }}</div>
          <div class="morer">
            <img src="../../assets/img/icon/people5.png" alt="" />
            <span style="text-align: right;">{{ item.playSum }}人</span>
          </div>
          <!-- <div class="bq" v-if="item.labelName">
            <div class="child" v-for="(key, k) in item.labelName.split(';')" :key="k">{{ key }}</div>
          </div> -->
        </div>
      </div>
    </div>

    <el-dialog :title="title" :visible.sync="centerDialogVisible" :close-on-click-modal="false"
      :before-close="closeVideo" width="50%" center>
      <video v-if="centerDialogVisible" :src="src" controls style="width: 100%" ref="video"></video>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeVideo">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      topCarse: {},
      list: [],
      title: '',
      src: '',
      centerDialogVisible: false,
      params: {
        userId: 0,
        courseId: 0
      }
    }
  },

  created () {
    this.params.userId = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).userId : 0
    this.getCarseList()
  },

  methods: {
    getCarseList () {
      let params = {
        page: 1,
        limit: 20
      }
      this.httphelper.get('/WebSiteApi/GetHCcourseInfoAllList', params).then(res => {
        if (res.code == 200) {
          this.topCarse = res.data.courseTopInfo
          this.list = res.data.courseList
        }
      })
    },

    addVideo () {
      this.httphelper.post('/WebSiteApi/AddHcClassched', this.params).then(res => {

      })
    },

    openVideo (item) {
      console.log(item)
      this.params.courseId = item.id
      this.title = item.title
      this.src = item.videoResUrl
      this.centerDialogVisible = true
      this.addVideo()
    },

    closeVideo () {
      console.log(this.$refs.video.currentTime)
      let params = {
        userId: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).userId : 0,
        courseid: this.params.courseId,
        watchTime: (this.$refs.video.currentTime / 60).toFixed(3),
        standingtime: (this.$refs.video.currentTime / 60).toFixed(3)
      }
      this.httphelper.post('/WebSiteApi/UptHCClasssched', params).then(res => {
      })
      this.centerDialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.morer {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #919ca3;
  line-height: 14px;
  text-align: right;

  img {
    margin-right: 8px;
    margin-top: -2px;
    width: 12px;
    height: 12px;
  }
}

.display_between_end {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.top3 {
  width: 1200px;
  margin: 0 auto;
  padding: 56px 0 60px 0;

  .tHeader {
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 24px;
    color: #000000;
  }

  .main {
    display: flex;
    margin-top: 30px;
    cursor: pointer;

    .first {
      position: relative;

      .bofang {
        width: 49px;
        height: 49px;
        position: absolute;
        left: 12px;
        top: 257px;
      }

      .img {
        width: 561px;
        height: 317px;
      }

      .title {
        width: 100%;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #000000;
      }

      .bq {
        display: flex;
        flex-wrap: wrap;
        margin-top: 30px;

        .child {
          padding: 3px 5px;
          border: 1px solid #979fa6;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #979fa6;
          margin-right: 3px;
        }
      }
    }

    .last {
      flex: 1;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-left: 20px;

      .item {
        width: 190px;
        position: relative;
        margin-bottom: 29px;
        cursor: pointer;

        .bofang {
          width: 30px;
          height: 30px;
          position: absolute;
          left: 10px;
          top: 66px;
        }

        .img {
          width: 190px;
          height: 106px;
        }

        .title {
          width: 100%;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #000000;
          line-height: 16px;
        }

        .bq {
          display: flex;
          flex-wrap: wrap;
          margin-top: 16px;

          .child {
            padding: 3px 5px;
            border: 1px solid #979fa6;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 12px;
            color: #979fa6;
            margin-right: 3px;
          }
        }
      }
    }
    .last::after {
      content: "";
      width: 190px;
    }
  }
}
</style>
